import { render } from "./ImagesList.vue?vue&type=template&id=6b240aee&scoped=true"
import script from "./ImagesList.vue?vue&type=script&lang=js"
export * from "./ImagesList.vue?vue&type=script&lang=js"

import "./ImagesList.vue?vue&type=style&index=0&id=6b240aee&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6b240aee"]])

export default __exports__